module.exports = __webpack_public_path__ + "static/media/cerik.547fad1b.png";